module.exports = __webpack_public_path__ + "img/tuijianchapin.34d7865f.png";